import React from "react";

import {
  handleAddLessonClicked,
  handleTodayClicked,
  handleViewSelected,
} from "../helpers";

import { MobileHeader } from "@ds-developer/calendar";
import {
  calendarActions,
  selectCalendarInitialDate,
  store,
} from "@hubcapp/state";
import { useSelector } from "react-redux";

const MobileCalendarHeaderStateProvider = () => {
  const initialDate =
    useSelector(selectCalendarInitialDate) || new Date(Date.now());

  const selectCalendarInitialDateHandler = (newDate?: Date) => {
    store.dispatch(
      calendarActions.calendarInitialDateChanged({ initialDate: newDate }),
    );
  };
  return (
    <MobileHeader
      handleViewSelected={handleViewSelected}
      handleTodayClicked={handleTodayClicked}
      handleAddEventClicked={handleAddLessonClicked}
      initialDate={initialDate}
      selectCalendarInitialDate={selectCalendarInitialDateHandler}
    />
  );
};
export default MobileCalendarHeaderStateProvider;
